import React from 'react';
import { Tabs } from '../components/ui/Tabs';
import { PostaInviataTab } from '../components/correspondence/PostaInviataTab';
import { PostaInArrivoTab } from '../components/correspondence/PostaInArrivoTab';
export function Corrispondenza() {
  return <div className="space-y-6 pb-16" data-id="element-2031">
      <div data-id="element-2032">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2033">Corrispondenza</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2034">
          Gestisci la corrispondenza con i clienti, monitora le comunicazioni
          inviate e ricevute
        </p>
      </div>
      <Tabs tabs={[{
      id: 'posta-inviata',
      name: 'Posta inviata',
      content: <PostaInviataTab data-id="element-2036" />
    }, {
      id: 'posta-in-arrivo',
      name: 'Posta in arrivo',
      content: <PostaInArrivoTab data-id="element-2037" />
    }]} data-id="element-2035" />
    </div>;
}